import { Component, DestroyRef, OnInit } from '@angular/core';
import { API, RoleDTO, UserClientFullDTO } from 'src/app/services/api/api';
import { ErrorService } from 'src/app/services/error.service';
import { UtilService } from 'src/app/services/util.service';
import { Mutable } from '../../../services/global/global-interfaces';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize, take } from 'rxjs/operators';

@Component({
  selector: 'app-user-profile-permissions',
  templateUrl: './user-profile-permissions.component.html',
  styleUrls: ['./user-profile-permissions.component.scss'],
  standalone: false,
})
export class UserProfilePermissionsComponent implements OnInit {
  loading: boolean;
  permissionCategoriesPreset: string[] = [
    'admin',
    'area',
    'campaign',
    'channel',
    'client',
    'company_attribute',
    'company',
    'cull_client',
    'cull_content',
    'cull_geo',
    'cull_player',
    'cull_time',
    'cull',
    'device_attribute',
    'device',
    'impersonate',
    'location_attribute',
    'location',
    'medium_group',
    'medium',
    'network_share',
    'notification',
    'planning',
    'playback_schedule',
    'pool',
    'reporting',
    'role',
    'user',
    'verification',
    'other',
  ];
  personalPermissions: string[] = [];
  permissionCategories: string[] = [];
  permissionCategoriesChunked: string[][] = [];

  categories: any = {};

  user: Mutable<UserClientFullDTO>;

  roles: RoleDTO[];

  constructor(
    private api: API,
    public util: UtilService,
    public errorHandler: ErrorService,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit(): void {
    this.refreshFromServer();
  }

  refreshFromServer() {
    this.loading = true;
    this.api
      .shared_Status_status()
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        take(1),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe({
        next: (data: UserClientFullDTO) => {
          this.user = data;
          this.getPermissionSettings();
        },
        error: error => {
          this.errorHandler.errorHandler(error);
        },
      });
  }

  getPermissionSettings() {
    this.api
      .shared_Client_retrievePersonalPermissions()
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        take(1),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe({
        next: (data: string[]) => {
          this.personalPermissions = data;
          this.personalPermissions.sort((one, two) => (one < two ? -1 : 1));
          this.permissionCategories = [];
          this.categories = {};
          for (const permission of this.personalPermissions) {
            let category = 'other';

            for (const cat of this.permissionCategoriesPreset) {
              if (permission.startsWith(cat)) {
                category = cat;
                break;
              }
            }

            if (!this.permissionCategories.includes(category)) {
              this.permissionCategories.push(category);
              this.categories[category] = [];
            }
            this.categories[category].push(permission);
          }

          this.permissionCategories.sort((one, two) => (one < two ? -1 : 1));

          const temp = this.permissionCategories.slice();

          this.permissionCategoriesChunked = [];
          const chunkSize = Math.ceil(this.permissionCategories.length / 3);

          while (temp.length) {
            this.permissionCategoriesChunked.push(temp.splice(0, chunkSize));
          }

          // TODO sortBySize necessary?
          const sortBySize: boolean = false;

          if (sortBySize) {
            this.permissionCategories.sort((one, two) => (this.categories[one].length < this.categories[two].length ? -1 : 1));
          }
        },
        error: error => {
          this.errorHandler.errorHandler(error);
        },
      });
  }
}
